export { default } from './HCPArticle';
export { default as relatedCardsAdapter } from '../RelatedCards/adapter';
export { default as RelatedCardsCarouselAdapter } from '../RelatedCards/adapter';
export { HIGHLIGHTED_CARD } from '../RelatedCards';
